
export default {
	
	inserted(el, binding) {
        var $window = $(window)
        var $el = $(el)
        var offset = 0
        var mode = 'fixed';
        var offsets = [];
        var vLimit = null;
        var observe_targets = [];
        
        if ( binding && binding.value ) {
            if ( binding.value.mode ) {
                mode = binding.value.mode;
            }
            
            if ( binding.value.offsets ) {
                offsets = binding.value.offsets;
            }
            
            if ( binding.value.vLimit ) {
                vLimit = binding.value.vLimit;
            }
        }
        
        // Build our offsets
        for ( let item of offsets ) {
            if ( parseInt(item) ) {
                offset += parseInt(item)
            } else if ( $(item).outerHeight() ) {
                offset += $(item).outerHeight()
            }
        }
    
        // Initialize the sticky element
        if ( !$el.attr('data-sticky-initialized') ) {
            // Work out where we naturally sit
            $window.on('resize', function () {
                var current_transform = $el.css('transform')
                var current_width = $el.css('width')
                var is_sticky = $el.is('[data-sticky]')
    
                $el.attr('data-sticky', null)
                $el.css({ transform: '', width: '' })
                $el.attr('data-natural-top', $el.offset().top)
                $el.attr('data-natural-left', $el.offset().left)
                $el.attr('data-natural-height', $el.outerHeight())
                $el.attr('data-natural-width', $el.outerWidth())
    
                if (is_sticky) {
                    $el.css({ transform: current_transform, width: current_width })
                    $el.attr('data-sticky', '1')
                }
    
                $window.trigger('scroll')
            })
    
            // Observe height changes in our element and anything related to it
            var observe_element = el
    
            do {
                observe_targets.push(observe_element);
                observe_element = observe_element.parentNode;
            } while ( !observe_element.matches('body') );
    
            if ( vLimit ) {
                observe_targets.push(document.querySelector(vLimit));
            }
    
            // Reposition when we scroll
            $window.on('scroll', function () {
                if ($el.attr('data-sticky-initialized')) {
                    var scrollTop = $window.scrollTop()
                    var natural_height = parseInt(el.getAttribute('data-natural-height'))
                    var natural_top = parseInt(el.getAttribute('data-natural-top'))
                    var natural_width = parseInt(el.getAttribute('data-natural-width'))
                    var final_offset_x = el.getAttribute('data-natural-left')
                    var final_offset_y = 0
    
                    if ( (scrollTop + offset) > natural_top ) {
                        el.setAttribute('data-sticky', '1')
    
                        // Vertical limiting
                        if ( vLimit ) {
                            var v_limit = 0
    
                            // Find our vertical limit
                            var $element = $(vLimit)
                            v_limit += $element.offset().top + $element.innerHeight() - natural_top - natural_height;
    
                            // See where the vertical limit on the bottom of our sticky element is
                            final_offset_y = (scrollTop + offset) - natural_top
    
                            // Work out if we're limited
                            if (final_offset_y > v_limit) {
                                el.classList.add('bottom-limited')
                                final_offset_x = 0
                            } else {
                                el.classList.remove('bottom-limited')
                            }
    
                            final_offset_y = Math.min(final_offset_y, v_limit)
                        } else {
                            final_offset_y = (scrollTop + offset) - natural_top
                        }
    
                        // Position how?
                        switch (mode) {
                            case 'absolute':
                                $el.css({ transform: 'translateY(' + final_offset_y + 'px)' })
                                break
                            case 'fixed':
                                $el.css({
                                    transform: 'translate(' + final_offset_x + 'px, ' + final_offset_y + 'px)',
                                    width: natural_width
                                })
                                break
                        }
                    } else {
                        el.removeAttribute('data-sticky');
                        el.classList.remove('bottom-limited');
                        el.style.transform = '';
                    }
                }
            })
    
            setTimeout(() => {
                el.setAttribute('data-sticky-initialized', '1');
                $window.trigger('resize')
            }, 500)
        }
        
        var observer = new ResizeObserver(entries => {
            $(window).trigger('resize')
        })
        
        for ( let target of observe_targets ) {
            observer.observe(target)
        }
	},
	
};